// test625
(625 && 0);
